/**
 * Bootstrap reader for the related-tags feature.
 *
 * Reads tag data from DOM mount points so that RelatedTagsRenderer
 * can initialise React islands without knowing the page template structure.
 *
 * Expected DOM structure (per tag container):
 *
 *   <div class="related-tags-root"
 *        data-tags-json='[{"title":"Foo","href":"/tag/foo"}]'>
 *     <!-- optional legacy content kept for graceful fallback -->
 *   </div>
 *
 * If `data-tags-json` is absent the element is skipped (legacy fallback).
 */
/**
 * Selector for new-style mount points that carry `data-tags-json`.
 */
const ROOT_SELECTOR = '.related-tags-root[data-tags-json]';
/**
 * Read all related-tags mount points from the current document.
 * Returns an empty array when no new-style mount points exist
 * (triggers legacy fallback in RelatedTagsRenderer).
 */
export function readAllRelatedTagsBootstrap() {
    const roots = Array.from(document.querySelectorAll(ROOT_SELECTOR));
    return roots.flatMap((el, idx) => {
        const json = el.getAttribute('data-tags-json');
        if (!json) {
            return [];
        }
        try {
            const items = JSON.parse(json);
            return [{ rootElement: el, items }];
        }
        catch (err) {
            console.warn('[RelatedTagsBootstrap] Failed to parse data-tags-json on root #%d:', idx, err);
            return [];
        }
    });
}
